import React from 'react';
import { LeafIcon } from 'lucide-react';
interface SectionDividerProps {
  color?: 'gold' | 'green' | 'cream';
  className?: string;
}
export function SectionDivider({
  color = 'gold',
  className = ''
}: SectionDividerProps) {
  const colorClass = {
    gold: 'text-ancestral-gold',
    green: 'text-ancestral-green',
    cream: 'text-ancestral-cream'
  }[color];
  const beforeAfterClass = {
    gold: 'border-ancestral-gold/30',
    green: 'border-ancestral-green/30',
    cream: 'border-ancestral-cream/30'
  }[color];
  return <div className={`flex items-center justify-center w-full max-w-xs mx-auto py-8 md:py-12 ${colorClass} ${className}`} aria-hidden="true" data-id="element-136">
      <div className={`h-px flex-1 border-t ${beforeAfterClass}`} data-id="element-137"></div>
      <LeafIcon className="w-6 h-6 mx-4 opacity-80" data-id="element-138" />
      <div className={`h-px flex-1 border-t ${beforeAfterClass}`} data-id="element-139"></div>
    </div>;
}